const Footer = () => {
  return (
    <footer>
      <p>© 2026 • Built with intention, shipped with pride • No templates, no BS</p>
    </footer>
  );
};

export default Footer;